import IconConsolidation from "../../component/SvgIcons/IconConsolidation";
import IconDistributor from "../../component/SvgIcons/IconDistributor";
import IconFreshTraining from "../../component/SvgIcons/IconFreshTraining";
import IconLicenseCost from "../../component/SvgIcons/IconLicenseCost";
import IconMarketData from "../../component/SvgIcons/IconMarketData";
import IconMisappropriation from "../../component/SvgIcons/IconMisappropriation";
import IconOtherDMS from "../../component/SvgIcons/IconOtherDMS";
import IconPainArea from "../../component/SvgIcons/IconPainArea";
import IconSoftwareInstallation from "../../component/SvgIcons/IconSoftwareInstallation";
import IconUnstructuredData from "../../component/SvgIcons/IconUnstructuredData";

const ChallengesList = [
  { title: "Pain Area", 
    icon:<IconPainArea/>,
},
  {
    title: "Non Availability of Market Data",
    icon:<IconMarketData/>,    
  },
  { title: "Unstructured Data",
    icon:<IconUnstructuredData/>,
     },
  {
    title: "Consolidation is virtually impossible",
    icon:<IconConsolidation/>,    
  },
  { title: "Misappropriation of Schemes",
    icon:<IconMisappropriation/>,
},
  { title: "Pain Areas Of Other DMS", 
    icon:<IconOtherDMS/>,
},
  {
    title: "Duplication of work for the Distributor",
    icon:<IconDistributor/>,
  },
  {
    title: "Additional software installation required",
    icon:<IconSoftwareInstallation/>,
  },
  {
    title: "Fresh training required for Distributor",
    icon:<IconFreshTraining/>,
  },
  { title: "Huge Support & license cost", 
    icon:<IconLicenseCost/>,
   },
];

export default ChallengesList;


export const FeaturesList = [
  "Minimal Change Management",
  "Sales Analytics and Trends",
  "Stock Out Scenarios",
  "Order Management",
  "Price Circulation and Control",
  "Stock Movement",
  "Better Procurement Planning",
  "Scheme Management",
  "Sales Tracking Capability at Primary, Secondary and Tertiary level.",
  "Seamless visibility across channels.",
  "Measure on Real-Time Accurate Sales Data.",
  "View on products movement across the channel.",
  "Effective Measurement of Target Vs Achievement.",
  "Better production planning with actual sales insights.",
  "Strong Sales & Marketing Activities based on market demand conditions.",
  "Reduced overall sales realization & processing time.",
  "Streamlined sales return and scheme settlement.",
  "Analyze local market demands and trends.",
  "Seamless claim settlements/Scheme settlements.",
  "Faster stock replenishment.",
  "Create an ecology of happy channel partners.",
  "Minimal Change Management",
  "Implementation Speed & Acceptability",
  "Service and Local Support via Partner Network",
  "Tally Presence - Indirect Benefits of Using Tally",
  "Multi Brand Outlet",
  "Master Control with Distributor Broadcasting",
  "Sales Target and Achievement"
]
